export default {
    data() {
        return {
            rules_required: [(val) => val !== null || "This field is required"],
            rules_string_limit: [
                (val) => (val || "").length <= 75 || "Max 75 characters",
            ],
            rules_text_limit: [
                (val) => (val || "").length <= 255 || "Max 255 characters",
            ],
            rules_input: [
                (val) => !!(val || "").length > 0 || "This field is required",
            ],
            rules_select: [(v) => !!v || v === 0 || "Item is required"],
            rules_email: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],
            rules_phone: [
                (v) => !!v || "Phone number is required",
                (v) =>
                    /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(
                        v
                    ) || "Phone number must be 10 digits",
            ],
            rules_zipCode: [
                (v) => !!v || "Zip code is required",
                (v) => /^\(?([0-9]{5})$/.test(v) || "Zip code must be 5 digits",
            ],
            rules_phoneNotRequired: [
                (v) =>
                    !(v || "").length ||
                    /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v)
                        ? true
                        : "Phone number must be 10 digits",
            ],
            rules_zipCodeNotRequired: [
                (v) =>
                    !(v || "").length || /^\(?([0-9]{5})$/.test(v)
                        ? true
                        : "Zip code must be 5 digits",
            ],
        };
    },
};
